module.exports = new __parcel__URL__("shop_common_ng_refill_image.d321c7a3.png").toString();